import React from "react";
import { getCardImage } from "../resultVisuals/cardAssets";

const WINNER_IMG = `${import.meta.env.BASE_URL}img/winner.png`;

// Reference: .casino-result-content-item > .casino-result-cards > [trophy] " " .d-inline-block(h4 + 3 cards)
function PlayerCards({ name, cards, isWinner }) {
  return (
    <div className="casino-result-content-item text-center">
      <div className="casino-result-cards">
        {isWinner && (
          <div className="casino-result-cards-item">
            <img src={WINNER_IMG} className="winner-icon" alt="" />
          </div>
        )}{" "}
        <div className="d-inline-block">
          <h4>{name}</h4>
          {cards.map((c, i) => (
            <React.Fragment key={i}>
              {" "}
              <div className="casino-result-cards-item">
                <img src={getCardImage(c)} alt="" />
              </div>
            </React.Fragment>
          ))}
        </div>
      </div>
    </div>
  );
}

const DESC_LABELS = ["Winner", "High Card", "Pair", "Color Plus", "Lucky 9"];

/**
 * Reference result body for 29Card Baccarat (teensin): cards A=[0,2,4], B=[1,3,5], trophy before the
 * winner's cards, rdesc "winner#highcard#pair#colorplus#lucky9" as Winner / High Card / Pair / Color Plus / Lucky 9.
 */
export default function TeensinResultBody({ t1 }) {
  const cards = String(t1?.card || "").split(",").map((c) => c.trim());
  const a = [cards[0], cards[2], cards[4]];
  const b = [cards[1], cards[3], cards[5]];
  const win = String(t1?.win ?? "");
  const desc = t1?.rdesc ? String(t1.rdesc).split("#") : [];

  return (
    <div className="row row5">
      <div className="col-12 col-lg-8">
        <div className="casino-result-content">
          <PlayerCards name="Player A" cards={a} isWinner={win === "1"} />{" "}
          <div className="casino-result-content-diveder" />{" "}
          <PlayerCards name="Player B" cards={b} isWinner={win === "2"} />
        </div>
      </div>{" "}
      <div className="col-12 col-lg-4">
        {desc.length ? (
          <div className="casino-result-desc">
            {DESC_LABELS.map((label, i) => (
              <React.Fragment key={label}>
                {i > 0 && " "}
                <div className="casino-result-desc-item">
                  <div>{label}</div> <div>{desc[i]}</div>
                </div>
              </React.Fragment>
            ))}
          </div>
        ) : null}
      </div>
    </div>
  );
}
